// frontend/src/pages/teacher/TeacherDiscussionPage.js (فایل جدید)

import React from 'react';
import { useParams, Link } from 'react-router-dom';
import DiscussionForum from '../../components/content/DiscussionForum';
import { FaArrowLeft } from 'react-icons/fa';

const TeacherDiscussionPage = () => {
    const { lessonId } = useParams();
    
    // (در آینده می‌توانیم ID دوره را هم بگیریم تا دکمه بازگشت هوشمندتر شود)
    
    return (
        <div className="page-container" style={{maxWidth: '900px'}}>
            <Link 
                to="/teacher/courses" // (بازگشت موقت به لیست کلی دوره‌ها)
                className="button button-secondary mb-6 inline-flex items-center"
            >
                <FaArrowLeft className="ml-2" /> بازگشت
            </Link>

            {/* کامپوننت تالار گفتگو که قبلا ساخته‌ایم، اینجا استفاده می‌شود */}
            <DiscussionForum lessonId={lessonId} />
        </div>
    );
};

export default TeacherDiscussionPage;